import React, {useContext} from 'react';
import './App.css';
import Footer from './components/Footer';
import Topbar from './components/Topbar';
import LandingPage from './pages/dashboard/LandingPage';
import { Route, Routes, Navigate } from 'react-router-dom';
import { ProductContext } from './ProductProvider';
import Sidebar from './components/Sidebar';
import { RoutesLocal } from './routes';
import './style.css';
import MyProfile from './pages/profile/MyProfile';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import MyBooks from './pages/books/MyBooks';

function App() {
  const { loggedUser, isSidebarOpen} = useContext(ProductContext);

  return (
    <div className="dashboard full_container inner_container">
     {loggedUser.isAuthenticated && <Sidebar />}
      <div id="content" className={!isSidebarOpen?"content":"content_max"}>
       {loggedUser.isAuthenticated && <Topbar /> }
        <div className='p-3'>
          <Routes>
          <Route path={RoutesLocal.Presentation.path} element={<LandingPage />} />
          <Route path={RoutesLocal.MyProfile.path} element={<MyProfile />} />
          <Route path={RoutesLocal.MyBooks.path} element={<MyBooks />} />
          <Route path={RoutesLocal.Signin.path} element={<Login />} />
          <Route path={RoutesLocal.ForgotPassword.path} element={<ForgotPassword />} />
          <Route path={RoutesLocal.ResetPassword.path} element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/" replace />}/>
        </Routes>
        </div>
        <div class="midde_cont">
        <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;
